import React from "react";
import useMenus from "../Global/useMenus";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import { Outlet } from "react-router";

const Home = () => {
  const { drawerMenu } = useMenus();
  return (
    <div>
      {/* <CommonLayout drawerMenu={drawerMenu}> */}
        <Outlet />
      {/* </CommonLayout> */}
    </div>
  );
};

export default Home;
